import {HTMLAttributes} from 'react';
import {twMerge} from '../../../common/twMerge';
import {Icon} from '../../atoms/Icon/Icon';
import {IconType} from '../../atoms/Icon/IconType.enum';
import {MenuTabList, MenuTabListItem} from '../MenuTabList/MenuTabList';

export interface FilterMenuOptionTabProps
  extends Omit<HTMLAttributes<HTMLDivElement>, 'onSelectTab' | 'onSelectSort'> {
  tabItems: MenuTabListItem[];
  selectedTab: string;
  onSelectTab: (param: string) => void;
  selectedSort: string;
  onSelectSort: () => void;
}

/**
 * 필터 메뉴와 정렬 옵션을 포함한 탭 컴포넌트
 * 좌측에는 카테고리 탭 목록, 우측에는 정렬 옵션을 표시합니다.
 */
export function FilterMenuOptionTab({
  tabItems,
  selectedTab,
  onSelectTab,
  selectedSort,
  onSelectSort,
  className,
  ...props
}: FilterMenuOptionTabProps) {
  return (
    <div
      className={twMerge(
        'bg-theme-solid-0 flex items-center justify-end gap-4pxr pl-11pxr pr-18pxr relative w-full py-12pxr',
        className
      )}
      {...props}
    >
      <div className="flex-1 flex items-center gap-4pxr relative mr-4pxr">
        <MenuTabList
          items={tabItems}
          selectedTab={selectedTab}
          onSelect={onSelectTab}
          className="min-w-0"
        />
      </div>

      <div className="flex items-center gap-16pxr shrink-0">
        <button
          className="flex items-center justify-center gap-4pxr h-32pxr"
          onClick={onSelectSort}
          type="button"
        >
          <Icon type={IconType.FilterSorting} alt="정렬" />
          <span className="font-small1 text-theme-solid-60">
            {selectedSort}
          </span>
        </button>
      </div>
    </div>
  );
}
